import { AppShell, Burger, Card } from "@mantine/core";
import "./TaxProReports.scss";
import { useDisclosure } from "@mantine/hooks";
import Header from "../../components/Tax Pro Only/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import InactiveClients from "../../components/InactiveClients/InactiveClients";
import { useEffect, useState } from "react";
import { getTaxProAnalytics } from "../../utils/api";
import CompletedClientsBar from "../../components/Tax Pro Only/TaxProMetrics/CompletedClientsBar/CompletedClientsBar";
import ClientProgressBar from "../../components/Tax Pro Only/TaxProMetrics/ClientProgressBar/ClientProgressBar";
import { inactiveOptions, optionStrings } from "../../constants";

const TaxProReports = () => {
  const [opened, { toggle }] = useDisclosure();
  const [analytics, setAnalytics] = useState<any>();
  const [selectedItem, setSelectedItem] = useState<string>(optionStrings[0]);

  useEffect(() => {
    const handleAnalytics = async () => {
      const response = await getTaxProAnalytics({
        age: inactiveOptions[selectedItem as keyof typeof inactiveOptions],
      });
      setAnalytics((response as any)?.data?.content);
    };

    handleAnalytics();
  }, [selectedItem]);

  // when page first loads scroll to the top so that all metrics are visible
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <AppShell
        className="home home-page"
        header={{ height: 87 }}
        navbar={{
          width: "15.375rem",
          breakpoint: "sm",
          collapsed: { mobile: !opened },
        }}
        padding="md"
      >
        <AppShell.Header className="app-header">
          <Burger
            className="burger"
            opened={opened}
            onClick={toggle}
            hiddenFrom="sm"
            size="sm"
          />
          <Header />
        </AppShell.Header>
        <AppShell.Navbar className="nav">
          <Sidebar />
        </AppShell.Navbar>
        <AppShell.Main className="main-container">
          <div className="main">
            <Card className="progress-bars">
              <h2>Client Progress</h2>
              <ClientProgressBar
                tooltip={`${
                  analytics?.clientStatus?.Completed === 1
                    ? "1 client"
                    : `${analytics?.clientStatus?.Completed} clients`
                }`}
                value={analytics?.clientCompletionBar}
              />
              <CompletedClientsBar
                clientStatusBar={analytics?.clientStatusBar}
                clientStatus={analytics?.clientStatus}
              />
            </Card>
          </div>
          <div className="second-container">
            <InactiveClients
              missingOrganizer={analytics?.clientInfo?.organizerNotCompleted}
              missingDocuments={analytics?.clientInfo?.documentsNotUploaded}
              missingIdentity={analytics?.clientInfo?.identityNotVerified}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            />
          </div>
        </AppShell.Main>
      </AppShell>
    </>
  );
};

export default TaxProReports;
